import { BigNumber } from '@ethersproject/bignumber';
import { formatUnits } from '@ethersproject/units';

export const calculateTxFee = (gasLimit: string, maxFeePerGas: string) => {
  return formatUnits(BigNumber.from(gasLimit).mul(BigNumber.from(maxFeePerGas)), 'wei');
};

export const calculateRoughFees = (
  gasLimits: { [protocolName: string]: { estimatedGas: string } } | null,
  gasPrice: string
) => {
  return gasLimits === null
    ? {}
    : Object.entries(gasLimits).reduce((acc, [protocolName, data]) => {
        acc[protocolName] = calculateTxFee(data?.estimatedGas || '21001', gasPrice);
        return acc;
      }, {} as { [protocolName: string]: string });
};
